import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
	organizationDealClassifierControllerListClassifiersOptions,
	organizationDealClassifierControllerListClassifiersQueryKey,
	organizationDealClassifierControllerSetClassifiersMutation,
} from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationOrganization } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

export const useDealDefaultsClassifiers = (organizationId: string) => {
	const tOrganization = useTranslationOrganization();
	const queryClient = useQueryClient();
	const path = { organizationId };

	const listQuery = useQuery({
		...organizationDealClassifierControllerListClassifiersOptions({ path }),
		enabled: !!organizationId,
	});

	const setMutation = useMutation({
		...organizationDealClassifierControllerSetClassifiersMutation(),
		onSuccess: async () => {
			await queryClient.invalidateQueries({
				queryKey: organizationDealClassifierControllerListClassifiersQueryKey({ path }),
			});
		},
		onError: () => {
			showToastV2({
				state: 'error',
				title: tOrganization('deal_defaults.classifiers.toast.save_failed'),
			});
		},
	});

	return {
		classifiers: listQuery.data?.classifiers ?? [],
		isCustomized: listQuery.data?.isCustomized ?? false,
		isLoading: listQuery.isLoading,
		setClassifiers: (names: string[]) => setMutation.mutate({ path, body: { names } }),
		isSaving: setMutation.isPending,
	};
};
